export function leafIsObject(leaf: unknown): leaf is Record<string, unknown> {
  return (
    typeof leaf !== "string" &&
    typeof leaf !== "number" &&
    !Array.isArray(leaf) &&
    leaf != null
  );
}
